(function () {
  if (window.FGSProductLandingLoaded) return;
  window.FGSProductLandingLoaded = true;

  function normalize(value) {
    return String(value == null ? '' : value).trim();
  }

  function normalizeKey(value) {
    return normalize(value).toLocaleLowerCase();
  }

  function isValidityGroup(group) {
    return normalize(group.dataset.landingOptionName) === 'Validity';
  }

  function variantOptions(variant) {
    return Array.isArray(variant.options)
      ? variant.options.map(normalize)
      : [variant.option1, variant.option2, variant.option3]
        .filter(function (value) { return value != null; })
        .map(normalize);
  }

  function sameOptions(variant, selectedOptions) {
    var options = variantOptions(variant);
    return options.length === selectedOptions.length && options.every(function (option, index) {
      return option === selectedOptions[index];
    });
  }

  function formatMoney(root, cents, formattedValue) {
    return window.FGSStorefrontMoney.format(cents, root.dataset.currency || 'IDR');
  }

  function initCompatibility(card) {
    var details = card.querySelector('.fgs-landing__compatibility');
    if (!details || details.dataset.landingCompatibilityReady === 'true') return;

    var summary = details.querySelector('summary');
    var reveal = details.querySelector('.fgs-landing__compatibility-reveal');
    if (!summary || !reveal) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var transitionTimer;
    var state = 'idle';
    var expanded = details.open;
    details.dataset.landingCompatibilityReady = 'true';
    reveal.style.height = details.open ? 'auto' : '0px';

    function finishOpen() {
      if (state !== 'opening') return;
      details.open = true;
      reveal.style.height = 'auto';
      state = 'idle';
    }

    function finishClose() {
      if (state !== 'closing') return;
      details.open = false;
      details.classList.remove('is-closing');
      reveal.style.height = '0px';
      state = 'idle';
    }

    function openDetails() {
      window.clearTimeout(transitionTimer);
      var startHeight = details.open ? reveal.getBoundingClientRect().height : 0;
      expanded = true;
      details.open = true;
      details.classList.remove('is-closing');
      reveal.style.height = startHeight + 'px';
      state = 'opening';

      if (reduceMotion.matches) {
        window.requestAnimationFrame(finishOpen);
        return;
      }

      window.requestAnimationFrame(function () {
        if (state !== 'opening') return;
        details.open = true;
        reveal.style.height = reveal.scrollHeight + 'px';
        transitionTimer = window.setTimeout(finishOpen, 320);
      });
    }

    function closeDetails() {
      window.clearTimeout(transitionTimer);
      expanded = false;
      details.open = true;
      reveal.style.height = reveal.getBoundingClientRect().height + 'px';
      details.classList.add('is-closing');
      state = 'closing';

      if (reduceMotion.matches) {
        window.requestAnimationFrame(finishClose);
        return;
      }

      window.requestAnimationFrame(function () {
        if (state !== 'closing') return;
        details.open = true;
        reveal.style.height = '0px';
        transitionTimer = window.setTimeout(finishClose, 320);
      });
    }

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      if (expanded) closeDetails();
      else openDetails();
    });

    details.addEventListener('toggle', function () {
      if (state === 'idle') expanded = details.open;
    });
    window.requestAnimationFrame(function () {
      if (state !== 'idle') return;
      expanded = details.open;
      reveal.style.height = details.open ? 'auto' : '0px';
    });
  }

  function initCard(root, card) {
    if (card.dataset.cardReady === 'true') return;

    initCompatibility(card);

    var json = card.querySelector('[data-landing-variants]');
    var buyButton = card.querySelector('[data-landing-buy]');
    if (!json || !buyButton) return;

    var variants;
    try { variants = JSON.parse(json.textContent); } catch (error) { variants = []; }
    if (!Array.isArray(variants) || variants.length === 0) return;

    card.dataset.cardReady = 'true';
    buyButton.dataset.defaultText = buyButton.textContent;

    var optionGroups = Array.from(card.querySelectorAll('[data-landing-option-index]'));
    var initialVariantId = String(card.dataset.initialVariant || '');
    var selectedVariant = variants.find(function (variant) { return String(variant.id) === initialVariantId; })
      || variants.find(function (variant) { return variant.available !== false; })
      || variants[0];
    var selectedOptions = variantOptions(selectedVariant);
    var isAdding = false;
    var productList = card.closest('[data-landing-product-group]');
    var productGroup = productList ? productList.dataset.landingProductGroup : '';
    var drawer = root.querySelector('[data-mobile-checkout-drawer]');
    var drawerId = drawer ? drawer.dataset.drawerId : '';
    var sourceId = card.id || ('landing-product-' + Math.random().toString(36).slice(2));
    card.id = sourceId;

    function drawerState() {
      return {
        drawerId: drawerId,
        sourceId: sourceId,
        sourceElement: card,
        productGroup: productGroup,
        productTitle: card.dataset.productTitle || '',
        productType: card.dataset.productType || 'sim',
        productTypeLabel: card.dataset.productTypeLabel || '',
        variant: selectedVariant,
        options: optionGroups.map(function (group) {
          return selectedOptions[Number(group.dataset.landingOptionIndex)];
        }).filter(function (value) { return value && normalizeKey(value) !== 'default title'; }),
        currency: root.dataset.currency,
        quantity: 1,
        formatMoney: function (cents) { return formatMoney(root, cents); }
      };
    }

    function updateOpenDrawer() {
      if (!drawerId || !selectedVariant) return;
      document.dispatchEvent(new CustomEvent('fgs:checkout-drawer:update', { detail: drawerState() }));
    }

    function variantAvailableForValue(index, value) {
      return variants.some(function (variant) {
        if (variant.available === false) return false;
        var options = variantOptions(variant);
        if (options[index] !== value) return false;

        return selectedOptions.slice(0, index).every(function (selected, previousIndex) {
          return options[previousIndex] === selected;
        });
      });
    }

    function renderOptionState() {
      optionGroups.forEach(function (group) {
        var index = Number(group.dataset.landingOptionIndex);
        group.querySelectorAll('[data-landing-option-value]').forEach(function (button) {
          var value = normalize(button.dataset.landingOptionValue);
          button.disabled = isAdding || !variantAvailableForValue(index, value);
          button.setAttribute('aria-pressed', String(selectedOptions[index] === value));
        });
      });
    }

    function renderVariant() {
      var price = card.querySelector('[data-landing-price]');
      var compare = card.querySelector('[data-landing-compare]');
      var compareRow = card.querySelector('[data-landing-compare-row]');
      var discountValue = card.querySelector('[data-landing-discount-value]');
      var error = card.querySelector('[data-landing-error]');

      selectedVariant = variants.find(function (variant) { return sameOptions(variant, selectedOptions); }) || null;
      renderOptionState();

      if (!selectedVariant) {
        buyButton.disabled = true;
        buyButton.textContent = root.dataset.unavailableText || 'Tidak tersedia';
        if (error) error.textContent = root.dataset.combinationError || 'Kombinasi ini tidak tersedia.';
        return;
      }

      if (error) error.textContent = '';
      price.textContent = formatMoney(root, selectedVariant.price, selectedVariant.formatted_price);
      var compareAt = Number(selectedVariant.compare_at_price || 0);
      var current = Number(selectedVariant.price || 0);
      if (compareAt > current) {
        compare.textContent = formatMoney(root, compareAt, selectedVariant.formatted_compare_at_price);
        discountValue.textContent = Math.round((compareAt - current) * 100 / compareAt) + '%';
        compareRow.hidden = false;
      } else {
        compareRow.hidden = true;
      }

      var unavailable = selectedVariant.available === false;
      buyButton.disabled = unavailable;
      buyButton.textContent = unavailable
        ? (root.dataset.soldOutText || 'Habis')
        : buyButton.dataset.defaultText;
      updateOpenDrawer();
    }

    function selectLowestValidity() {
      var validityGroup = optionGroups.find(isValidityGroup);
      if (!validityGroup) return;
      var validityIndex = Number(validityGroup.dataset.landingOptionIndex);
      var orderedValues = Array.from(validityGroup.querySelectorAll('[data-landing-option-value]')).map(function (button) {
        return normalize(button.dataset.landingOptionValue);
      });

      for (var valueIndex = 0; valueIndex < orderedValues.length; valueIndex += 1) {
        var value = orderedValues[valueIndex];
        var match = variants.find(function (variant) {
          if (variant.available === false) return false;
          var options = variantOptions(variant);
          if (options[validityIndex] !== value) return false;
          return selectedOptions.every(function (selected, index) {
            return index === validityIndex || options[index] === selected;
          });
        });
        if (match) {
          selectedOptions = variantOptions(match);
          return;
        }
      }
    }

    function selectOption(index, value, broadcast) {
      selectedOptions[index] = normalize(value);
      var availableVariant = variants.find(function (variant) {
        if (variant.available === false) return false;
        var options = variantOptions(variant);
        return selectedOptions.slice(0, index + 1).every(function (selected, selectedIndex) {
          return options[selectedIndex] === selected;
        });
      });
      if (availableVariant) selectedOptions = variantOptions(availableVariant);
      renderVariant();

      var group = optionGroups.find(function (candidate) {
        return Number(candidate.dataset.landingOptionIndex) === index;
      });
      if (broadcast && group && isValidityGroup(group)) {
        root.dispatchEvent(new CustomEvent('landing:validity-change', {
          detail: { value: normalize(value), productGroup: productGroup, source: card }
        }));
      }
    }

    optionGroups.forEach(function (group) {
      var index = Number(group.dataset.landingOptionIndex);
      group.querySelectorAll('[data-landing-option-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          selectOption(index, button.dataset.landingOptionValue, true);
        });
      });
    });

    root.addEventListener('landing:validity-change', function (event) {
      if (!event.detail || event.detail.source === card || event.detail.productGroup !== productGroup) return;
      var group = optionGroups.find(isValidityGroup);
      if (!group) return;
      var button = Array.from(group.querySelectorAll('[data-landing-option-value]')).find(function (candidate) {
        return normalizeKey(candidate.dataset.landingOptionValue) === normalizeKey(event.detail.value);
      });
      if (!button || button.disabled) return;
      selectOption(Number(group.dataset.landingOptionIndex), button.dataset.landingOptionValue, false);
    });

    selectLowestValidity();
    renderVariant();

    buyButton.addEventListener('click', function (event) {
      if (!selectedVariant || selectedVariant.available === false || isAdding) return;
      if (drawerId && window.matchMedia('(max-width: 1023px)').matches) {
        document.dispatchEvent(new CustomEvent('fgs:checkout-drawer:open', {
          detail: Object.assign(drawerState(), { focusOnOpen: event.detail === 0 })
        }));
        return;
      }
      var error = card.querySelector('[data-landing-error]');
      var rootUrl = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var variantToAdd = selectedVariant;
      isAdding = true;
      renderOptionState();
      buyButton.disabled = true;
      buyButton.textContent = root.dataset.addingText || 'Menambahkan…';
      if (error) error.textContent = '';

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantToAdd.id, quantity: 1 }] })
      }).then(function (response) {
        if (!response.ok) return response.json().then(function (body) {
          throw new Error(body.description || root.dataset.addError || 'Produk tidak dapat ditambahkan.');
        });
        return response.json();
      }).then(function () {
        buyButton.textContent = root.dataset.addedText || 'Ditambahkan';
        setTimeout(function () {
          isAdding = false;
          renderVariant();
        }, 1200);

        return fetch(rootUrl + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (response) {
            if (!response.ok) throw new Error(root.dataset.cartError || 'Keranjang tidak dapat diperbarui.');
            return response.json();
          })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { item_count: Number(cart.item_count || 0) }
            }));
          })
          .catch(function (reason) {
            if (error) error.textContent = reason.message || root.dataset.cartError || 'Keranjang tidak dapat diperbarui.';
          });
      }).catch(function (reason) {
        isAdding = false;
        renderVariant();
        if (error) error.textContent = reason.message || root.dataset.addError || 'Coba lagi.';
      });
    });
  }

  function initLanding(root) {
    if (!root || root.dataset.landingReady === 'true') return;
    root.dataset.landingReady = 'true';
    var tabs = Array.from(root.querySelectorAll('[data-landing-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-landing-panel]'));

    function selectTab(tab) {
      tabs.forEach(function (button) {
        var selected = button.dataset.landingTab === tab;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(function (panel) {
        var selected = panel.dataset.landingPanel === tab;
        panel.hidden = !selected;
      });
    }

    tabs.forEach(function (button, index) {
      button.addEventListener('click', function () { selectTab(button.dataset.landingTab); });
      button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = tabs[(index + direction + tabs.length) % tabs.length];
        selectTab(next.dataset.landingTab);
        next.focus();
      });
    });

    root.querySelectorAll('[data-landing-product]').forEach(function (card) { initCard(root, card); });
    var initialTab = tabs.find(function (button) { return button.getAttribute('aria-selected') === 'true'; }) || tabs[0];
    if (initialTab) selectTab(initialTab.dataset.landingTab);

    document.addEventListener('fgs:checkout-drawer:edit', function (event) {
      if (!event.detail || !event.detail.sourceElement || !root.contains(event.detail.sourceElement)) return;
      var card = event.detail.sourceElement;
      if (event.detail.productGroup && tabs.length) selectTab(event.detail.productGroup);
      window.requestAnimationFrame(function () {
        card.setAttribute('tabindex', '-1');
        window.scrollTo({ top: window.scrollY + card.getBoundingClientRect().top - 96, behavior: 'smooth' });
        card.focus({ preventScroll: true });
        card.classList.add('is-edit-target');
        window.setTimeout(function () {
          card.classList.remove('is-edit-target');
          card.removeAttribute('tabindex');
        }, 1400);
      });
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-product-landing]').forEach(initLanding);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
